import 'CssFolder/user-role-function-map/user-role-function-map-table.scss';
import { Checkbox } from 'construct-ui';
import paginationComponent from '../../components/pagination/pagination.component';
import POSMAuthorizationModel from '../../models/posm/posm-authority.model';
import ViewBase from '../view-base.view';

export default function POSMAuthorizationView() {
  ViewBase.call(this);

  const DESCENDING_TEXT = 'DESC';
  const ASCENDING_TEXT = 'ASC';


  const authorityList = [
    { code: 'topCateNewInd', name: this.getText('LT00001290', 'New Goods Type') },
    { code: 'mainCateNewInd', name: this.getText('LT00001291', 'New Division') },
    { code: 'subCateNewInd', name: this.getText('LT00001292', 'New Model') },
    { code: 'goodsNewInd', name: this.getText('LT00001293', 'New Basic Model') },
    { code: 'warehouseNewInd', name: this.getText('LT00001294', 'New Warehouse') },
    { code: 'storageNewInd', name: this.getText('LT00001295', 'New Storage Location') },
    { code: 'grNewInd', name: this.getText('LT00001296', 'Goods Receive') },
    { code: 'wmNewInd', name: this.getText('LT00001297', 'Goods Movement') },
    { code: 'giNewInd', name: this.getText('LT00001298', 'Goods Issue') },
    { code: 'reNewInd', name: this.getText('LT00001299', 'Goods Return') },
    { code: 'scNewInd', name: this.getText('LT00001300', 'Scrap Goods') },
    { code: 'grEditInd', name: this.getText('LT00001301', 'Edit Goods Receive(All)') },
    { code: 'wmEditInd', name: this.getText('LT00001302', 'Edit Goods Movement(All)') },
    { code: 'giEditInd', name: this.getText('LT00001303', 'Edit Goods Issue(All)') },
    { code: 'reEditInd', name: this.getText('LT00001304', 'Edit Goods Return(All)') },
    { code: 'scEditInd', name: this.getText('LT00001305', 'Edit Scrap(All)') },
    { code: 'showPriceInd', name: this.getText('LT00001306', 'Show Pricing Info') },
    { code: 'regionalMapInd', name: this.getText('LT00001307', 'Regional Mapping') },
    { code: 'warehouseMapInd', name: this.getText('LT00001308', 'Warehouse Mapping') },
    { code: 'giApplicationInd', name: this.getText('LT00001309', 'Goods Issue Application') },
    { code: 'giConfirmInd', name: this.getText('LT00001310', 'Confirm Goods Issue') },
  ]

  let tableDataHasChanged = false
  let tableData = [];
  let selectedUserRole = null;

  let selectedSortBy = '';
  let selectedOrderBy = "";

  const pagination = {
    pageIndex: 1,
    pageSize: 10,
    totalItems: 0,
  };

  const getPOSMAuthorizationList = () => {
    this.showLoading();
    POSMAuthorizationModel.getAuthorizationList({
      pageSize: pagination.pageSize,
      pageIndex: pagination.pageIndex,
      sortBy: selectedSortBy,
      orderBy: selectedOrderBy,
    })
      .then((result) => {
        tableData = result?.data || [];

        pagination.totalItems = result?.total || 0;
        pagination.pageIndex = result?.pageIndex || 1;
        pagination.pageSize = result?.pageSize || 10;
      })
      .catch((error) => {
        this.handleError(error);
      })
      .finally(() => {
        this.hideLoading();
      });
  };


  const handlePageChanged = (page) => {
    pagination.pageIndex = page;
    getPOSMAuthorizationList();
  };

  const handlePageSizeChanged = (page, size) => {
    pagination.pageIndex = page;
    pagination.pageSize = size;
    getPOSMAuthorizationList();
  };

  const handleUpdateUserRoleDataAccess = () => {
    this.showLoading();
    let { userRoleCode, ...payload } = selectedUserRole;

    POSMAuthorizationModel.updateAuthorization({ userRole: userRoleCode, ...payload })
      .then((result) => {
        this.showMessage(
          this.getText("EM00000762", "Changes have been saved."),
          this.getText("EM0000004", "Success"),
          getPOSMAuthorizationList
        );
        selectedUserRole = null;
      })
      .catch((error) => this.handleError(error))
      .finally(() => {
        tableDataHasChanged = false;
        this.hideLoading();
      });
  };

  const handleDownloadExcel = () => {
    this.showLoading();
    POSMAuthorizationModel.downloadAuthorityList({
      pageSize: pagination.pageSize,
      pageIndex: pagination.pageIndex,
      sortBy: selectedSortBy,
      orderBy: selectedOrderBy,
    })
      .catch((error) => {
        this.handleError(error);
      })
      .finally(() => {
        this.hideLoading();
      });
  }

  const leavePageEventListener = (e) => {
    if (tableDataHasChanged && !confirm(this.getText('EM00000776', 'Changes you made may not be saved'))) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  };

  const renderUpdateField = () => {
    const rowQty = Math.ceil(authorityList.length / 4)
    let res = [];
    for (let i = 0; i < rowQty; i++) {
      for (let j = 0; j < 4; j++) {
        let item = authorityList[j * rowQty + i]
        if (item) {
          res.push(
            m('.col-md-3.position-relative.g-1',
              m(Checkbox, {
                checked: selectedUserRole[item.code],
                onchange: (e) => {
                  tableDataHasChanged = true;
                  selectedUserRole[item.code] = e.target.checked;
                }
              }),
              m('label.form-label', { for: item.code }, item.name)
            ),
          )
        } else res.push(m('.col-md-3'))
      }

    }
    return res
  }

  const flipOrderText = (orderText) => {
    return orderText.toUpperCase() === DESCENDING_TEXT ? ASCENDING_TEXT : DESCENDING_TEXT;
  }

  const getSortIcon = (orderBy) => {
    if (selectedOrderBy !== orderBy) {
      return null;
    }

    return selectedSortBy === DESCENDING_TEXT
      ? m('i.bi.bi-sort-down')
      : m('i.bi.bi-sort-up');
  };

  const onSortClick = (orderBy) => {
    if (selectedOrderBy === orderBy) {
      selectedSortBy = flipOrderText(selectedSortBy);
    } else {
      selectedOrderBy = orderBy;
      selectedSortBy = DESCENDING_TEXT;
    }
    getPOSMAuthorizationList();
  };

  return {
    oncreate: () => {
      addEventListener('route', leavePageEventListener);
      addEventListener('beforeunload', leavePageEventListener);
    },
    onremove: () => {
      removeEventListener('route', leavePageEventListener);
      removeEventListener('beforeunload', leavePageEventListener);
    },
    oninit: () => {
      getPOSMAuthorizationList();
    },
    view: () => {
      return [
        // Table section
        m('.card.mb-3',
          m('.card-body',
            m('.row.g-2',
              m('.col-12',
                m('.d-flex.justify-content-end.mb-2',
                  m('a.btn.btn-primary',
                    { onclick: handleDownloadExcel },
                    m('i.bi.bi-file-earmark-arrow-down-fill'), this.getText("LT00000018", "Excel Download"),
                  )
                )
              ),
              m('.col-12.p-0',
                m('.table-responsive.table-fixed-header',
                  m('table.table.table-hover.sticky-column-start.posm-authority-table', [
                    m('thead.thead-bggrey',
                      m('tr.align-middle', { style: 'position: sticky; top: 1px; z-index: 2; box-shadow: 0px -1px var(--is-link-blue)' },
                        m('th[scope="col"]',
                          {
                            onclick: () => { onSortClick("userRole") },
                          },
                          getSortIcon('userRole'),
                          this.getText("LT00000060", "User Role")
                        ),
                        authorityList.map(({ name, code }) =>
                          m('th[scope="col"]',
                            {
                              onclick: () => { onSortClick(code) },
                            },
                            getSortIcon(code),
                            name
                          )
                        )
                      )
                    ),
                    m('tbody',
                      (tableData.length == 0) &&
                      m('tr.align-middle',
                        m('td', { colspan: authorityList.length + 1 }, this.getText("EM00000141", "No records found."))
                      ),
                      tableData.length > 0 &&
                      tableData.map((row) => {
                        return m('tr.align-middle',
                          m('td', {
                            style: 'z-index:1'
                          },
                            m('button.btn.btn-link', {
                              onclick: () => {
                                selectedUserRole = structuredClone(row);
                              }
                            },
                              row.userRoleName)
                          ),
                          authorityList.map(({ code }) =>
                            m('td',
                              m(Checkbox, {
                                style: 'cursor: default',
                                checked: row[code],
                                readonly: true
                              })
                            ))
                        )
                      })
                    )
                  ])
                ),
                m(".px-3",
                  m(paginationComponent, {
                    currentPage: pagination.pageIndex,
                    pageSize: pagination.pageSize,
                    totalItems: pagination.totalItems,
                    data: tableData,
                    onPageChanged: handlePageChanged,
                    onPageSizeChanged: handlePageSizeChanged,
                  })
                )
              )
            )
          )
        ),
        // Table section - end

        selectedUserRole &&
        m('.card',
          m('.card-header.ps-3.d-flex.justify-content-between.gap-2', { style: "border: none" },
            m('h2.secondary-title.card-title', this.getText('LT00000498', 'Update') + ' (' + selectedUserRole.userRoleName + ')'),
            m('.d-flex.justify-self-end.gap-2',
              m('button.btn.btn-primary', { onclick: handleUpdateUserRoleDataAccess },
                this.getText("LT00000022", "Save")
              ),
              m('button.btn.btn-white', { onclick: () => { selectedUserRole = null; } },
                this.getText("LT00000021", "Close")
              )

            ),
          ),
          m('.card-body',
            m('.row.g-2',
              renderUpdateField()
            ),
          )
        ),

        this.getBaseViews()
      ];
    }
  };
}
